import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockCheckModel } from "../stockCheckModel";
import { IStockCheckDetail } from "../stockCheckType"
import YhTag from "@/components/YhTag";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

type statusType = {
    "stocktaking.complete": string,
    "stocktaking.create": string,
    "stocktaking.change": string,
    [key: string]: any
}
export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useStockCheckModel();
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();

    const statusColor: statusType = {
        "stocktaking.complete": "blue",
        "stocktaking.create": "cyan",
        "stocktaking.change": "red",
    }
    let Result: any = {
        "盘盈": Locale["Surplus"],
        "盘亏": Locale["Loss"],
        "相符": Locale["Equal"],
    }
    const columns: ColumnsType<IStockCheckDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            // dataIndex: 'branch',
            fixed: "left",
            render: (t, r, i) => `${i + 1}`
        }, {
            // title: '盘点单号',
            title: Locale["Stocktaking Doc No."],
            width: 150,
            fixed: "left",
            dataIndex: 'stocktakingCode',
        }, {
            // title: '盘点时间',
            title: Locale["Stocktaking Time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'createTime',
        }, {
            // title: '盘点状态',
            title: Locale["Stocktaking status"],
            width: 160,
            dataIndex: 'status',
            // render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
        }, {
            // title: '单据类型',
            title: Locale["Document  Type"],
            width: 160,
            dataIndex: 'type',
            render: (text) => text == "1" ? Locale["Stocktaking Doc"] : Locale["initialization Doc"]
            // options: [{ label: Locale["initialization Doc"], value: "0" }, { label: Locale["Stocktaking Doc"], value: "1" }],
        }, {
            // title: '系统库存',
            title: Locale["System Inventory"],
            width: 160,
            dataIndex: 'bookTotalNum',
        }, {
            // title: '盘点库存',
            title: Locale["Stocktaking Inventory"],
            width: 160,
            dataIndex: 'realTotalNum',
        }, {
            // title: '盘盈总数',
            title: Locale["Stocktaking Surplus Qty"],
            width: 120,
            dataIndex: 'surplusItem',
        }, {
            // title: '盘亏总数',
            title: Locale["Stocktaking Loss Qty"],
            width: 160,
            dataIndex: 'lossItem',
        }, {
            // title: '差异金额',
            title: Locale["Difference Amount"],
            width: 160,
            dataIndex: 'differenceTotalAmount',
        }, {
            // title: '盘点结果',
            title: Locale["Result"],
            width: 160,
            dataIndex: 'result',
            render: (text) => Result[text]
        }, {
            // title: '制单人',
            title: Locale["Creator"],
            width: 160,
            dataIndex: 'createUser',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 160,
            dataIndex: 'note',
        }
    ];
    useEffect(() => {
        loadData().then();
    }, [])
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.stocktakingCode as string}
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockCheckDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.stocktakingCode) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.stocktakingCode as string]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
